import script from "./ListDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ListDetail.vue?vue&type=script&setup=true&lang=js"

import "./ListDetail.vue?vue&type=style&index=0&id=2a08690b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a08690b"]])

export default __exports__